import StandardTabPanel from "../../../ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../ui library/components/tab-panels/standard/tab-header/tab-styles";

export default function Navigation({ providerId, activeTab, children }) {
  const allTabs = [
    {
      key: "location-info",
      name: "Location Info",
      isDisabled: false,
      permission: null,
      href: `/provider/${providerId}/location-info/hours-of-operation`,
    },
    {
      key: "management",
      name: "Management",
      isDisabled: false,
      permission: null,
      href: `/provider/${providerId}/management/`,
    },
  ];

  return (
    <div className="transparent relative flex h-full flex-1 flex-col items-stretch rounded-[15px] shadow-[3px_3px_10px_0px_rgb(188,209,255)]">
      <StandardTabPanel
        activeTab={activeTab}
        tabList={allTabs}
        headerTabSx={TAB_STYLES.TAB.SX}
        headerTabIndicatorSx={TAB_STYLES.TAB.TAB_INDICATOR_SX}
      >
        {children}
      </StandardTabPanel>
    </div>
  );
}
